(()=>{'use strict';let mounted=false;const esc=(value='')=>String(value).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  function mount() {
    if (mounted) return;
    mounted = true;
    document.querySelectorAll('.card-alternate').forEach(img => img.addEventListener('error', () => {
      img.closest('.luna-media-card').classList.add('alternate-unavailable');
    }, { once:true }));
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-card-alternate]');
      if (!button) return;
      const card = button.closest('.luna-media-card');
      const active = card.classList.toggle('show-alternate');
      button.setAttribute('aria-pressed', String(active));
      button.title = active ? 'Product view' : button.dataset.alternateLabel;
      const title = card.querySelector('h3')?.textContent || 'this piece';
      button.setAttribute('aria-label', `Show ${active ? 'product view' : button.dataset.alternateLabel.toLowerCase()} of ${title}`);
    });
    document.addEventListener('click', event => {
      if (!event.target.closest('.site-return-top a, .journal-reading-end a[href="#main"]')) return;
      event.preventDefault();
      event.stopPropagation();
      const main = document.getElementById('main');
      if (main) { main.tabIndex = -1; main.focus({ preventScroll: true }); }
      window.scrollTo({ top: 0, behavior: 'instant' });
    }, true);
    mountViewer();
  }

  function mountGalleryNavigation(frames) {
    const feed = frames[0].closest('.pdp-gallery-feed');
    const gallery = feed?.closest('.pdp-gallery');
    if (!gallery || frames.length < 2) return;
    const mobile = window.matchMedia('(max-width: 900px)');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    feed.id ||= 'pdp-image-feed';
    feed.tabIndex = 0;
    const controls = document.createElement('div');
    controls.className = 'pdp-gallery-controls';
    controls.setAttribute('role', 'group');
    controls.setAttribute('aria-label', 'Product image navigation');
    controls.innerHTML = `<button type="button" data-gallery-step="-1" aria-label="Previous product image" aria-controls="${feed.id}"><span class="site-arrow site-arrow--left" aria-hidden="true"></span></button><button type="button" data-gallery-step="1" aria-label="Next product image" aria-controls="${feed.id}"><span class="site-arrow" aria-hidden="true"></span></button>`;
    gallery.append(controls);
    const previous = controls.querySelector('[data-gallery-step="-1"]');
    const next = controls.querySelector('[data-gallery-step="1"]');
    let requested = null;
    let settleTimer;
    const positions = () => {
      const left = feed.getBoundingClientRect().left;
      const max = Math.max(0, feed.scrollWidth - feed.clientWidth);
      return frames.map(frame => Math.max(0, Math.min(max, frame.getBoundingClientRect().left - left + feed.scrollLeft)));
    };
    const nearest = values => values.reduce((best, value, i) => Math.abs(value - feed.scrollLeft) < Math.abs(values[best] - feed.scrollLeft) ? i : best, 0);
    function sync() {
      if (!mobile.matches) return;
      const current = requested ?? nearest(positions());
      previous.disabled = current === 0;
      next.disabled = current === frames.length - 1;
    }
    function settled() { requested = null; clearTimeout(settleTimer); sync(); }
    function move(target) {
      if (!mobile.matches) return;
      const values = positions();
      requested = Math.max(0, Math.min(values.length - 1, target));
      feed.scrollTo({ left:values[requested], behavior:reduced.matches ? 'instant' : 'smooth' });
      sync();
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settled, 180);
    }
    controls.addEventListener('click', event => {
      const button = event.target.closest('[data-gallery-step]');
      if (!button || button.disabled) return;
      move((requested ?? nearest(positions())) + Number(button.dataset.galleryStep));
    });
    feed.addEventListener('scroll', () => {
      sync();
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settled, 180);
    }, { passive:true });
    feed.addEventListener('scrollend', settled);
    feed.addEventListener('pointerdown', settled, { passive:true });
    feed.addEventListener('wheel', settled, { passive:true });
    feed.addEventListener('keydown', event => {
      if (!mobile.matches || event.target !== feed) return;
      const current = requested ?? nearest(positions());
      const target = {ArrowLeft:current - 1, ArrowRight:current + 1, Home:0, End:frames.length - 1}[event.key];
      if (target === undefined) return;
      event.preventDefault();
      move(target);
    });
    window.addEventListener('resize', settled);
    mobile.addEventListener('change', settled);
    sync();
  }

  function mountViewer() {
    const frames = [...document.querySelectorAll('.pdp-gallery-item')];
    if (!frames.length) return;
    mountGalleryNavigation(frames);
    const main = document.querySelector('.pdp-main');
    const product = {title:main.querySelector('h1').textContent};
    const gallery = frames.map(frame => ({ src:frame.querySelector('img').getAttribute('src'), alt:frame.querySelector('img').alt, role:frame.dataset.galleryRole }));
    const dialog = document.createElement('dialog');
    dialog.className = 'image-viewer';
    dialog.setAttribute('aria-labelledby', 'image-viewer-title');
    dialog.innerHTML = `<div class="image-viewer-toolbar"><h2 id="image-viewer-title">${esc(product.title)}</h2><button type="button" data-viewer-close aria-label="Close image viewer">Close <span aria-hidden="true">×</span></button></div>
      <div class="image-viewer-stage" data-viewer-stage><img data-viewer-image alt="" /></div>
      <div class="image-viewer-controls"><button type="button" data-viewer-step="-1" aria-label="Previous image"><span class="site-arrow site-arrow--left" aria-hidden="true"></span></button><span data-viewer-position aria-live="polite"></span><button type="button" data-viewer-step="1" aria-label="Next image"><span class="site-arrow" aria-hidden="true"></span></button><button type="button" data-viewer-zoom aria-pressed="false">Zoom in</button></div>
      <p class="image-viewer-caption" data-viewer-caption></p>`;
    document.body.append(dialog);
    const image = dialog.querySelector('[data-viewer-image]');
    const stage = dialog.querySelector('[data-viewer-stage]');
    const zoomButton = dialog.querySelector('[data-viewer-zoom]');
    let index = 0;
    let opener = null;
    let zoomed = false;

    function setZoom(value) {
      zoomed = value;
      stage.classList.toggle('is-zoomed', value);
      zoomButton.setAttribute('aria-pressed', String(value));
      zoomButton.textContent = value ? 'Fit image' : 'Zoom in';
      requestAnimationFrame(() => {
        stage.scrollLeft = value ? Math.max(0, (image.clientWidth - stage.clientWidth) / 2) : 0;
        stage.scrollTop = value ? Math.max(0, (image.clientHeight - stage.clientHeight) / 2) : 0;
      });
    }
    function display(nextIndex) {
      index = Math.max(0, Math.min(gallery.length - 1, nextIndex));
      const entry = gallery[index];
      image.src = entry.src;
      image.alt = entry.alt;
      setZoom(false);
      dialog.querySelector('[data-viewer-position]').textContent = `${index + 1} / ${gallery.length}`;
      dialog.querySelector('[data-viewer-step="-1"]').disabled = index === 0;
      dialog.querySelector('[data-viewer-step="1"]').disabled = index === gallery.length - 1;
      dialog.querySelector('[data-viewer-caption]').textContent = entry.role === 'wearing' ? 'On model' : entry.role === 'main' ? 'Product view' : 'A closer look at the details';
    }
    function open(nextIndex, trigger) {
      opener = trigger;
      display(nextIndex);
      dialog.showModal();
      document.body.classList.add('image-viewer-open');
      dialog.querySelector('[data-viewer-close]').focus();
    }
    function cleanup() {
      document.body.classList.remove('image-viewer-open');
      if (opener?.isConnected) opener.focus({ preventScroll:true });
    }
    frames.forEach((frame, position) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'image-enlarge-button';
      button.setAttribute('aria-label', `Enlarge image ${position + 1} of ${gallery.length}`);
      button.innerHTML = '<span aria-hidden="true">⤢</span>';
      button.addEventListener('click', () => open(position, button));
      frame.append(button);
      frame.querySelector('img').addEventListener('click', () => open(position, button));
    });
    dialog.querySelector('[data-viewer-close]').addEventListener('click', () => dialog.close());
    dialog.querySelectorAll('[data-viewer-step]').forEach(button => button.addEventListener('click', () => display(index + Number(button.dataset.viewerStep))));
    zoomButton.addEventListener('click', () => setZoom(!zoomed));
    image.addEventListener('click', () => setZoom(!zoomed));
    dialog.addEventListener('close', cleanup);
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        display(index + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
  }

mount();})();
